import React from "react";
import { myApps } from "../data/apps";
import ProductCard from "./ProductCard";

const ProductsSection: React.FC = () => {
  return (
    <section id="products" className="py-20 sm:py-28 lg:py-32 bg-brand-bg-alt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-text mb-4">
            我们的产品
          </h2>
          <div className="w-16 h-0.5 bg-brand-border mx-auto mb-4" />
          <p className="text-lg text-brand-text-secondary max-w-2xl mx-auto">
            精心打造每一款应用，只为给你更好的体验
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {myApps.map((app, index) => (
            <ProductCard key={index} app={app} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
